export default {
  setYupLocale__FORM_FIELD_NOT_VALID: "Enter a valid ${path}.",
  setYupLocale__FORM_FIELD_REQUIRED: "Enter ${path}.",
};
